export function getSkipPage(page, skip = 10) {
  return (page - 1) * skip;
}
